import { useEffect, useState } from "react";
import { getRestaurantList } from "../services/restaurant";
import { RestaurantList } from "../models/IRestaurantDetail";
import { PromoCodesContent } from "../components/PromoCodesContent";

export default function AdminPromoCodesPage() {
  const [restaurantList, setRestaurantList] = useState<RestaurantList>();
  const [selectedId, setSelectedId]         = useState("");

  useEffect(() => {
    getRestaurantList().then(res => { if (res.data) setRestaurantList(res.data); });
  }, []);

  return (
    <div style={{ padding: "24px", maxWidth: 960, margin: "0 auto" }}>
      {/* Header */}
      <div style={{ marginBottom: 24 }}>
        <h4 style={{ fontWeight: 800, color: "#111827", marginBottom: 4 }}>
          <i className="bi bi-tag-fill me-2" style={{ color: "#7c3aed" }}></i>Promosyon Kodları — Admin
        </h4>
        <p style={{ color: "#6b7280", fontSize: "0.88rem", margin: 0 }}>
          Restoran seçin, ardından o restoranın promosyon kodlarını yönetin.
        </p>
      </div>

      {/* Restoran seçici */}
      <div style={{ marginBottom: 24, maxWidth: 420 }}>
        <label style={{ fontSize: "0.78rem", fontWeight: 600, color: "#374151", display: "block", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.05em" }}>
          <i className="bi bi-building me-1"></i>Restoran
        </label>
        <select
          className="form-select form-select-lg"
          style={{ borderRadius: 12, border: "1.5px solid #dee2e6", boxShadow: "0 2px 8px rgba(0,0,0,.06)", fontWeight: 500 }}
          value={selectedId}
          onChange={e => setSelectedId(e.target.value)}
        >
          <option value="" disabled>Restoran seçiniz...</option>
          {restaurantList?.items.map(r => (
            <option key={r.id} value={r.id}>{r.restourantName}</option>
          ))}
        </select>
      </div>

      {!selectedId ? (
        <div style={{ textAlign: "center", padding: "60px 0", color: "#9ca3af" }}>
          <i className="bi bi-tag" style={{ fontSize: "2.5rem", display: "block", marginBottom: 10 }}></i>
          <span style={{ fontSize: "0.9rem" }}>Promosyon kodlarını görüntülemek için restoran seçin.</span>
        </div>
      ) : (
        <PromoCodesContent restaurantId={selectedId} showHeader={false} />
      )}
    </div>
  );
}
